
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/natural-loose-diamonds/[[...slug]]",
      function () {
        return require("private-next-pages/natural-loose-diamonds/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/natural-loose-diamonds/[[...slug]]"])
      });
    }
  